import React from 'react';

import Thumbnail from 'src/app/thumbnail/Thumbnail';

const EditorContainer = ({ params, location }) => (
  <Thumbnail
    viewParams={params}
    query={location.query}
    shortcode={params.shortcode}
  />
);

export default EditorContainer;
